module.exports = __webpack_public_path__ + "static/media/chev-right.8d570ea1.svg";